import AppConstants from '@/appConstants';
import store from '@/store';
import { ref, watch } from '@vue/composition-api'
// import store from '@/store'

export default function useCalendarEventSendNews(props) {
  // ------------------------------------------------
  // eventLocal
  // ------------------------------------------------
  
  console.log('[useCalendarEventDetail]',props.newsViewData);
  const eventLocal = ref(JSON.parse(JSON.stringify(props.newsViewData.value)))
  const resetEventLocal = () => {
    eventLocal.value = JSON.parse(JSON.stringify(props.newsViewData.value))
  }
  watch(props.newsViewData, () => {
    console.log('[watch][props.newsViewData]',props.newsViewData);
    resetEventLocal()
  })

  const createSendNewsTab = (isEdit = false, isCopy = false, isErrata = false, editData = {}, draftData = {}, template = AppConstants.NEWS_LAYOUT.NEWS) => {
    // displaySendNewsForm.value = false;
    setTimeout(() => {
      store.dispatch("report/newTab", {
        isEdit: isEdit, 
        isCopy: isCopy, 
        isErrata: isErrata, 
        editData: editData, 
        draftData: draftData,
        startTemplate: template
      });
    }, 300);
    // store.dispatch("report/updateTabIndex");
  };

  // ------------------------------------------------
  // isEventHandlerSidebarActive
  // * Clear form if sidebar is closed
  // ------------------------------------------------
  // watch(props.isEventHandlerSidebarActive, val => {
  //   // ? Don't reset event till transition is finished
  //   // if (!val) {
  //   //   setTimeout(() => {
  //   //     clearForm.value()
  //   //   }, 350)
  //   // }
  // })

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  // ------------------------------------------------
  // guestOptions
  // ------------------------------------------------

  /* eslint-disable global-require */
  
  /* eslint-enable global-require */

  return {
    eventLocal,
    resetEventLocal,
    createSendNewsTab,

    // UI
   
  }
}
